module.exports = __webpack_public_path__ + "static/img/product-1.7e3c8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/product-1.png
// module id = bslZ
// module chunks = 1